import { useTranslation } from "react-i18next";

export const SecurityVerification = () => {
  const { t } = useTranslation();
  return (
    <div className="security-verification text-center">
      <p style={{ marginBottom: "10px" }}>{t("booking.secure_type")}</p>
      <div className="d-flex justify-content-center align-items-center gap-3">
        <div>
          <img
            src="/pngwing.com.png" // Replace with PCI DSS logo URL
            alt="PCI DSS Compliant"
            style={{ width: "120px" }}
          />
        </div>
        <div>
          <img
            src="/clipart2051305.png" // Replace with SSL logo URL
            alt="SSL Secure"
            style={{ width: "120px" }}
          />
        </div>
        <div>
          <img
            src="sha256-encrypt-decrypt.svg" // Replace with SHA-256 logo URL
            alt="SHA-256 Encrypted"
            style={{ width: "42px" }}
          />
        </div>
      </div>
    </div>
  );
};
